/*
 *  -----------------------------------------------------------------------
 *    <copyright file="assessments-svt-grid.data.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { GridColumnMenuActiveFilter } from '@components/core/grid-filters';
import { useGridCells } from '@hooks/index';
import { GridColumnDateFilterV2 } from '@components/core/grid-filters-v2';

const { YesNoCell, NumberCell, DateCell, MaxLengthCell } = useGridCells();

export const ASSESSMENT_SVT_COLUMNS = (translate: Function) => [
    {
        field: 'active',
        label: translate('admin:active'),
        minWidth: 140,
        id: 'assessment-active',
        cells: { data: YesNoCell },
        filterUi: GridColumnMenuActiveFilter,
    },
    {
        field: 'name',
        label: translate('admin:name'),
        minWidth: 140,
        id: 'assessment-name',
        lockedByDefault: true,
        cells: { data: MaxLengthCell(50) },
    },
    {
        field: '_assessmentRules',
        label: translate('admin:additionalRules'),
        minWidth: 150,
        id: 'assesments-additional-rules',
        cells: { data: MaxLengthCell(50) },
    },
    {
        field: 'endPoint',
        label: translate('admin:endPoint'),
        minWidth: 160,
        id: 'assessment-end-point',
        cells: { data: YesNoCell },
        filterUi: GridColumnMenuActiveFilter,
    },
    {
        field: 'safety',
        label: translate('admin:safety'),
        minWidth: 140,
        id: 'assessment-safety',
        cells: { data: YesNoCell },
        filterUi: GridColumnMenuActiveFilter,
    },
    {
        field: 'lab',
        label: translate('admin:lab'),
        minWidth: 140,
        id: 'assessment-lab',
        cells: { data: YesNoCell },
        filterUi: GridColumnMenuActiveFilter,
    },
    {
        field: 'sendToVendor',
        label: translate('admin:sendToVendor'),
        minWidth: 190,
        id: 'assessment-send-vendor',
        cells: { data: YesNoCell },
        filterUi: GridColumnMenuActiveFilter,
    },
    {
        field: '_crfName',
        label: translate('admin:crfName'),
        minWidth: 140,
        id: 'assessment-crf-name',
        cells: { data: MaxLengthCell(30) },
    },
    {
        label: translate('ra:createdBy'),
        id: 'assessment-createdby',
        field: '_createdByString',
        minWidth: 180,
    },
    {
        label: translate('ra:createdDate'),
        id: 'assessment-created',
        minWidth: 200,
        field: 'created',
        cells: { data: DateCell },
        filter: 'date',
        filterUi: GridColumnDateFilterV2,
    },
    {
        label: translate('ra:updatedBy'),
        id: 'assessment-updatedby',
        field: '_updatedByString',
        minWidth: 180,
    },
    {
        label: translate('ra:updatedDate'),
        field: 'updated',
        id: 'assessment-updated',
        minWidth: 200,
        filter: 'date',
        cells: { data: DateCell },
        filterUi: GridColumnDateFilterV2,
    },
    {
        field: 'recordId',
        label: translate('id'),
        minWidth: 120,
        id: 'assessment-id',
        filter: 'numeric',
        cells: { data: NumberCell },
        showByDefault: false,
    },
];

export const ASSESSMENTS_MODAL_CLOSE_ACTIONS = {
    ERROR: 'error',
    SUCCESS: 'success',
    UNASSIGN: 'unassign',
    SUCCESS_AND_CLOSE: 'success-and-close',
};
